import clientFetcher from '@finance/clientFetcher';
import { Temporal } from '@js-temporal/polyfill';
import { Document } from 'fluent-graphql';
import type { AccountTransfer, Errors, TypedObject } from '../types';

export interface UpdateCrossCurrencyAccountTransferReturn {
  updateCrossCurrencyAccountTransfer: AccountTransfer | { reference: string } & TypedObject | Errors;
}

interface UpdateCrossCurrencyAccountTransferVars {
  organizationId: string;
  accountTransferId: string;
  input: unknown;
}

export default Document
  .mutation<UpdateCrossCurrencyAccountTransferReturn, UpdateCrossCurrencyAccountTransferVars>('UpdateCrossCurrencyAccountTransfer')
    .variableDefinitions({ organizationId: 'ID!', accountTransferId: 'ID!', input: 'UpdateCrossCurrencyAccountTransferInput!' })
    .union('updateCrossCurrencyAccountTransfer')
      .useVariables({ organizationId: 'organizationId',  accountTransferId: 'accountTransferId', input: 'input' })
      .onEntity('AccountTransfer')
        .scalar('organizationId')
        .scalar('date', Temporal.PlainDate.from)
        .reference('sourceCurrencyId', 'Currency')
        .reference('targetCurrencyId', 'Currency')
        .reference('sourceAccountId', 'Account')
        .reference('targetAccountId', 'Account')
        .scalar('sourceAmount')
        .scalar('targetAmount')._
      .onTypedObject('NegativeAccountBalance')
        .scalar('name')
        .scalar('currencyName')
        .scalar('balanceAmount')._
      .onTypedObject('NegativeWalletBalance')
        .scalar('name')
        .scalar('currencyName')
        .scalar('balanceAmount')._
      .onTypedObject('MismatchedAmountCrossCurrencyAccountWalletTransfers')
        .scalar('currentServerTime')._
      .onTypedObject('InputErrors')
        .scalar('errors')._._._
  .makeExecutable(clientFetcher)
  .afterExecution(({ updateCrossCurrencyAccountTransfer: data }) => {
    if (data.__typename === 'AccountTransfer') {
      Document.clearQueries([
        'AccountTransfers',
        'WalletTransfers',
        'WalletTransactions',
        'AccountTransactions',
        'Accounts',
        'Wallets'
      ]);
    }
  });
